import script from "./Checklist.vue?vue&type=script&setup=true&lang=js"
export * from "./Checklist.vue?vue&type=script&setup=true&lang=js"

import "./Checklist.vue?vue&type=style&index=0&id=bd57b4e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd57b4e4"]])

export default __exports__